<header class="top-bar">
    <button type="button" class="menu-btn" (click)="toggleNav()" aria-label="Menu" aria-controls="main-nav">
        <mat-icon aria-hidden="true">menu</mat-icon>
    </button>
    <a class="brand" routerLink="/">
        <img class="brand-logo" src="assets/jera-logo.svg" alt="JERA Global Markets">
        <span class="brand-divider" aria-hidden="true"></span>
        <span class="brand-name">{{ appName }}</span>
        <span *ngIf="environmentName" class="brand-env">{{ environmentName }}</span>
    </a>

    <button type="button" class="avatar" [matMenuTriggerFor]="profileMenu" aria-label="Open profile menu">
        {{ initials }}
    </button>
    <mat-menu #profileMenu="matMenu" xPosition="before" class="account-menu">
        <div class="account-who">
            <p class="account-name">{{ displayName }}</p>
            <p class="account-email">{{ profile?.userPrincipalName }}</p>
        </div>
        <a mat-menu-item routerLink="/profile">
            <mat-icon>person</mat-icon>View Profile
        </a>
        <a mat-menu-item routerLink="/">
            <mat-icon>home</mat-icon>Home
        </a>
        <mat-divider></mat-divider>
        <button mat-menu-item class="account-logout" (click)="logout()">
            <mat-icon>logout</mat-icon>Log Out
        </button>
    </mat-menu>

    <mat-progress-bar *ngIf="loadingService.isLoading | async" class="top-bar-progress" mode="indeterminate"></mat-progress-bar>
</header>
